import {
  TextField,
  Box,
  useTheme,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Breadcrumbs,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  FormLabel,
  CircularProgress,
  ToggleButton,
} from "@mui/material";
import dayjs from "dayjs";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import axios from "axios";
import store from "../../..";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import * as Yup from "yup";
import {
  fetchProjectRoleData,
  postData,
  ProjectTeamsTreeData,
  rolepost,
  rolepostData,
  sprintGetData,
  sprintprojectplanGetData,
} from "../../../store/reducers/Formapireducer";
import { Field } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { tokens } from "../../../Theme";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowModes,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import { Formik } from "formik";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import MultiSelectTreeView from "./TreeView";
import PersonRemoveAlt1Icon from "@mui/icons-material/PersonRemoveAlt1";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';



const Editrole = (selectedRow) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;
  var mode = params.Mode;
  var filtertype = params.filtertype;
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const SprintGEtdata = useSelector((state) => state.formApi.sprintget) || {};
  const sprintPPgetloading = useSelector(
    (state) => state.formApi.sprintloading
  );
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const YearFlag = sessionStorage.getItem("YearFlag");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const CompanyID = sessionStorage.getItem("companyId");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const EMPID = sessionStorage.getItem("EmpId");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const sliceSubscriptionCode = SubscriptionCode.slice(-3);

  const location = useLocation();
  const state = location.state || {};
  const [rows, setRows] = useState([]);

  console.log('====================================');
  console.log(rows, '------');
  console.log('====================================');
  const [pageSize, setPageSize] = React.useState(10);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const TreeData = useSelector((state) => state.formApi.TreeData);
  const TreeDataloading = useSelector((state) => state.formApi.TreeDataloading);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const ClassificationRecID = sessionStorage.getItem("ClassificationRecID");
  const ClassificationData = JSON.parse(
    sessionStorage.getItem("ClassificationData") || "[]"
  );

  console.log(ClassificationData, "--find getItem ClassificationData");

  const filteredClassification = ClassificationData.filter(
    (item) => item.CfcName !== "Student"
  );
  const classificationIDs = filteredClassification.map(
    (item) => item.CfcID
  );

  const classificationIDString = classificationIDs
    .map((id) => `'${id}'`)
    .join(",");
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          sortorder: Yup.string().required(data.Projectteam.sortorder),
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    dispatch(ProjectTeamsTreeData({ ProjectID: params.id }));
    const url = store.getState().globalurl.projectRoleurl;

    const payload = { EmployeeProjectFilter: params.id };
    axios
      .post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })
      .then((response) => {
        if (response.data.Data) {

          setRows(response.data.Data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch data", err);
        setError("Failed to fetch data");
      })
      .finally(() => setLoading(false));
  }, [params.id]);

  const [recid, setRecid] = useState(null);
  const [rowModesModel, setRowModesModel] = useState({});
  const [funMode, setFunMode] = useState(mode);
  const [open, setOpen] = useState(false);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState(null);
  const [selectedScheduledToOptions, setSelectedScheduledToOptions] =
    useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [editRowId, setEditRowId] = useState(null);
  const [sortorder, setSortorder] = useState(null);

  const InitialValue = {
    // code: SprintGEtdata.Code,
    // name: SprintGEtdata.Name,
    // Milestone: SprintGEtdata.MilestoneID
    //   ? {
    //     RecordID: SprintGEtdata.MilestoneID,
    //     Name: SprintGEtdata.MilestoneName,
    //   }
    //   : "",
    // OperationStage: SprintGEtdata.OperationStageID
    //   ? {
    //     RecordID: SprintGEtdata.OperationStageID,
    //     Name: SprintGEtdata.OperationName,
    //   }
    //   : null,
    // Activities: SprintGEtdata.ActivitiesID
    //   ? {
    //     RecordID: SprintGEtdata.ActivitiesID,
    //     Name: SprintGEtdata.ActivitiesName,
    //   }
    //   : null,
    // fromdate: SprintGEtdata.FromDate,
    // todate: SprintGEtdata.ToDate,

    Leader: null,
    ScheduledTo: [],
    sortorder: "",
    disable: false,
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
    setSelectedRoleOptions(null);
    setSelectedScheduledToOptions(null);
  };

  const fnLogOut = (props) => {
    //   if(Object.keys(ref.current.touched).length === 0){
    //     if(props === 'Logout'){
    //       navigate("/")}
    //       if(props === 'Close'){
    //         navigate("/Apps/TR022/Bank Master")
    //       }

    //       return
    //  }
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };

  const [rowCount, setRowCount] = useState(0);
  const [showRemoved, setShowRemoved] = useState(false);
  function Custombar({ rowCount, showRemoved, setShowRemoved }) {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2, // padding left and right
          py: 1,
        }}
      >
        {/* Title with count */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* <Typography variant="subtitle1">List of Project Members</Typography> */}
          <Typography variant="subtitle1">List of Incharge And Personnel</Typography>
            {/* {is003Subscription ? "List of Class Teachers And Students" : "List of Project Members"}</Typography> */}
          <Typography variant="h6">{`(${rowCount})`}</Typography>
        </Box>

        {/* Toggle Button */}
        <ToggleButton
          value="check"
          selected={showRemoved}
          onChange={() => setShowRemoved((prev) => !prev)}
          sx={{ height: 36 }}
        >
          {showRemoved ? <VisibilityIcon sx={{ mr: 1 }} /> : <VisibilityOff sx={{ mr: 1 }} />}
          Show Removed Members
        </ToggleButton>
      </GridToolbarContainer>
    );
  }

  const processRowUpdate = (newRow, oldRow) => {
    const isNew = !oldRow?.RecordID;
    const updatedRow = { ...newRow, isNew };

    setRows((prev) => {
      const index = prev.findIndex(
        (row) => row.RecordID === updatedRow.RecordID
      );
      if (index !== -1) {
        const newData = [...prev];
        newData[index] = updatedRow;
        return newData;
      }
      return [...prev, updatedRow];
    });
    return updatedRow;
  };

  const handleDeleteClick = async (row, isRemove) => {

    if (row.Status == "Incharge") {
      return toast.error("Project Incharge cannot be removed.")
    }
    const accessID = "TR268";
    const action = "softdelete";

    const idata = {
      RecordID: row.RecordID,
      ProjectID: params.id,
      DesignationID: row.DesignationID,
      EmployeeID: row.EmployeeID,
      SortOrder: row.SortOrder,
      Disable: isRemove ? "Y" : "N",
      TeamManagerID: row.TeamManagerID,
    };

    try {
      const response = await dispatch(postData({ accessID, action, idata }));

      if (response.payload.Status === "Y") {
        toast.success(isRemove ? "Removed Successfully" : "Added Successfully");
        dispatch(ProjectTeamsTreeData({ ProjectID: params.id }));

        const url = store.getState().globalurl.projectRoleurl;
        const payload = { EmployeeProjectFilter: params.id };

        axios
          .post(url, payload, {
            headers: {
              Authorization:
                "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
            },
          })
          .then((response) => {
            if (response.data.Data) {

              setRows(response.data.Data || []);
            }
          })
          .catch((err) => {
            console.error("Failed to fetch data", err);
            setError("Failed to fetch data");
          })
          .finally(() => setLoading(false));
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Delete failed", error);
      toast.error("Delete failed");
    }
  };

  const Sprintcolumns = [
    { field: "SLNO", headerName: "SL#", width: 50 },
    // {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    // },
     {
      headerName: "Incharge",
      // headerName: is003Subscription ? "Class Teacher" : "Team Leader",
      field: "TeamManagerName",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "Designation",
      field: "DesignationName",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
   
    {
      headerName: "Personnel",
      // headerName: is003Subscription ? "Students" : "Team Member",
      field: "EmployeeName",
      width: "200",
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "ERank",
      field: "ERank",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "TeamManagerID",
      field: "TeamManagerID",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "Status",
      field: "Status",
      width: "100",
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "Sort Order",
      field: "SortOrder",
      width: "75",
      align: "right",
      headerAlign: "center",
      // hide: false,
      hide: true,
      editable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: (params) =>
        params.row.Disable == "N"
          ? [
            <GridActionsCellItem
              icon={<PersonRemoveAlt1Icon style={{ color: "red" }} />}
              label="remove" // ← Update label from "Edit" to "Delete"
              onClick={() => handleDeleteClick(params.row, true)}
              color="inherit"
            />,
          ]
          : [
            <GridActionsCellItem
              icon={<GroupAddIcon color="info" />}
              label="Add" // ← Update label from "Edit" to "Delete"
              onClick={() => handleDeleteClick(params.row, false)}
              color="inherit"
            />,
          ],
    },
  ];

  const Fnsave = async (values, resetForm) => {
    let action = editRowId ? "update" : "insert";
    let isCheck = values.disable ? "Y" : "N";
    let accessID = "TR268";

    if (!selectedDesignation || !values.ScheduledTo?.length) {
      toast.error("Please select Team Leader and at least one Team Member.");
      return;
    }

    const managerData = {
      RecordID: "-1",
      ProjectID: params.id,
      DesignationID: selectedDesignation.DesignationID || "",
      EmployeeID: "0",
      SortOrder: sortorder || 1,
      Disable: "N",
      TeamManagerID: selectedDesignation.EmployeeID,
      ManagerName: selectedDesignation.Name,
    };

    const memberData = values.ScheduledTo.map((emp, index) => ({
      RecordID: "-1",
      ProjectID: params.id,
      DesignationID: emp.DesignationID || "",
      EmployeeID: emp.RecordID,
      EmployeeName: emp.Name,
      //SortOrder: (index + 2).toString(),
      SortOrder: sortorder || 1,
      Disable: "N",
      TeamManagerID: selectedDesignation.EmployeeID,
    }));

    const idata = {
      managerdata: managerData,
      memberData: memberData,
    };

    const response = await dispatch(
      postData({
        accessID,
        action,
        idata,
      })
    );
    console.log(response, "insertresponse");
    if (response.payload.Status === "Y") {
      const projectRoleResponse = await dispatch(
        fetchProjectRoleData({ EmployeeProjectFilter: params.id })
      );
      dispatch(ProjectTeamsTreeData({ ProjectID: params.id }));

      if (projectRoleResponse.type === "projectRole/fetch/fulfilled") {
        setRows(projectRoleResponse.payload.Data);
      } else {
        console.error("Failed to fetch project role data", projectRoleResponse);
        setError("Failed to fetch data");
      }
      setLoading(false);
      toast.success(response.payload.Msg);
      setEditRowId(null);
      setSelectedDesignation(null);
      resetForm();
      setSortorder("");
    } else {
      toast.error(response.payload.Msg);
    }
  };

  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Breadcrumbs
              maxItems={2}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default", marginLeft: "10px" }}
                onClick={() => {
                  {
                    is003Subscription ?
                      navigate("/Apps/TR133/Classes") :
                      navigate("/Apps/TR133/Project")
                  }
                }}
              >
                {/* {`Project(${state.projectName})`} */}
                {is003Subscription ? `Classes(${state.projectName})` : `Project(${state.projectName})`}
              </Typography>

              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
                onClick={() => navigate(-1)}
              >
                Incharge And Personnel
                {/* Team */}
                {/* {is003Subscription ? "Class Teachers And Students" : "Team"} */}
              </Typography>
            </Breadcrumbs>
          </Box>

          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px", padding: "10px" }}>
        <Formik
          initialValues={InitialValue}
          // validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setTimeout(() => {
              Fnsave(values, resetForm);
            }, 100);
          }}
          enableReinitialize={true}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" gap={2}>
                {/* Left Side: DataGrid */}
                <Box flex={2} height={500}>
                  {!getLoading && (
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                        "& .MuiDataGrid-root": { border: "none" },
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: colors.blueAccent[800],
                        },
                        "& .MuiDataGrid-virtualScroller": {
                          backgroundColor: colors.primary[400],
                        },
                        "& .MuiDataGrid-footerContainer": {
                          backgroundColor: colors.blueAccent[800],
                        },
                        "& .odd-row": {
                          backgroundColor: "",
                        },
                        "& .even-row": {
                          backgroundColor: "#D3D3D3",
                        },
                      }}
                      rows={showRemoved ? rows?.filter((v) => v.Disable == "Y") : rows?.filter((v) => v.Disable == "N")}
                      columns={Sprintcolumns}
                      loading={sprintPPgetloading}
                      rowModesModel={rowModesModel}
                      getRowId={(row) => row.RecordID}
                      editMode="cell"
                      disableRowSelectionOnClick
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      experimentalFeatures={{ newEditingApi: true }}
                      onRowModesModelChange={handleRowModesModelChange}
                      processRowUpdate={processRowUpdate}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      components={{
                        Toolbar: Custombar,
                      }}
                      componentsProps={{
                        toolbar: {
                          rowCount: rows.length,
                          showRemoved,
                          setShowRemoved,
                        },
                      }}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                    />
                  )}
                </Box>

                <Box flex={1} display="flex" flexDirection="column" gap={2}>
                  <Productautocomplete
                    name="Leader"
                     label="Incharge"
                    // label={is003Subscription ? "Class Teacher" : "Team Leader"}
                    id="Leader"
                    value={selectedDesignation}
                    onChange={(newValue) => setSelectedDesignation(newValue)}
                    getOptionLabel={(option) => option?.Name || ""}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2112","ScreenName":"Team Leader","Filter":"ProjectID='${recID}'AND ClassificationID IN(${classificationIDString})","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}
                    url={
                      is003Subscription
                        ? `${listViewurl}?data={"Query":{"AccessID":"2112","ScreenName":"Team Leader","Filter":"ProjectID='${recID}'AND ClassificationID IN(${classificationIDString})","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                        : `${listViewurl}?data={"Query":{"AccessID":"2112","ScreenName":"Team Leader","Filter":"ProjectID='${recID}'","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                    }
                  
                  />
                  <MultiFormikOptimizedAutocomplete
                    name="ScheduledTo"
                     label="Personnel"
                    // label={is003Subscription ? "Student" : "Team Member"}
                    id="ScheduledTo"
                    value={values.ScheduledTo}
                    onChange={(event, newValue) =>
                      setFieldValue("ScheduledTo", newValue)
                    }
                    getOptionLabel={(option) => option?.Name || ""}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2113","ScreenName":"Team Member","Filter":"ManagerID='${selectedDesignation?.EmployeeID || ""}'","Any":"", "VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}

                    url={
                      is003Subscription
                        ? `${listViewurl}?data={"Query":{"AccessID":"2166","ScreenName":"Students","Filter":"ProjectID=${params.id} OR ProjectID IS NULL AND CompanyID=${CompanyID}","Any":"","CompId":${CompanyID},"VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                        : `${listViewurl}?data={"Query":{"AccessID":"2113","ScreenName":"Team Member","Filter":"ManagerID='${selectedDesignation?.EmployeeID || ""}'","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                    }
                  />

                  <TextField
                    name="sortorder"
                    type="number"
                    id="sortorder"
                    // label={
                    //   <>Sort Order<span style={{ color: "red", fontSize: "20px" }}>*</span></>
                    // }
                    label="Sort Order"
                    variant="standard"
                    focused
                    // required
                    value={sortorder}
                    onBlur={handleBlur}
                    onChange={(e) => setSortorder(e.target.value)}
                    // error={!!touched.actualHours && !!errors.actualHours}
                    // helperText={touched.actualHours && errors.actualHours}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                      },
                    }}
                    onInput={(e) => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 8);
                    }}
                  />

                  <Box
                    display="flex"
                    justifyContent="end"
                    padding={1}
                    gap="20px"
                  // marginTop={-5}
                  >
                    <LoadingButton
                      color="secondary"
                      variant="contained"
                      type="submit"
                    // loading={isLoading}
                    >
                      Save
                    </LoadingButton>
                    <Button
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      minHeight: 220,
                      flexGrow: 1,
                      // maxWidth: 400,
                      border: 1,
                      borderRadius: 2,
                      p: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Incharge And Personnel
                      {/* Project Team */}
                      {/* {is003Subscription ? "Class Teachers And Students" : "Project Team"} */}
                    </Typography>

                    {TreeDataloading ? (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight={180} // reduced to account for title
                      >
                        <CircularProgress size={24} />
                      </Box>
                    ) : (
                      <MultiSelectTreeView
                        data={TreeData}
                        loading={TreeDataloading}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
    </React.Fragment>

  );


}

export default Editrole;
